<template>
    <div>
        <img class="bgImg" src="@/assets/default/two.png" alt="" />
        <div class="describe">抱歉！页面暂时走丢……</div>
    </div>
</template>

<script>
export default {
    data() {
        return {

        };
    },
    methods: {
        
    },
    mounted() {

    },
};
</script>

<style lang="scss" scoped>
.bgImg{
    display: block;
    margin: 200px auto 30px;
}
.describe{
    text-align: center;
    font-size: 24px;
    color: #333333;
}
</style>